var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('gmaps-map',{on:{"mounted":_vm.ready}}),_c('input',{ref:"autocomplete",staticClass:"formfield",attrs:{"id":"autocomplete","placeholder":"Search"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }